export enum QuizEvaluationType {
  RESULTS_AT_END = 'results_at_end',
  RESULTS_AFTER_SELECTION = 'results_after_selection',
  RESULTS_AND_CORRECT_ANSWER_AFTER_SELECTION = 'results_and_correct_answer_after_selection',
}
